/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useMemo, useState } from "react";
import { IconContext } from "react-icons";
import { BsFillHeartFill as Heart } from "react-icons/bs";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import "swiper/css";
import { useServiceLikeMutation } from "../../../Hooks/Mutations/ServiceMutation/useLikeMutation";
import useAuth from "../../../Hooks/useAuth";
import Login from "../../../sections/Login/Login";
import { SignUp } from "../../../sections/SignUp/SignUp";
import "./card.css";
import SecondaryHeading from "../Typography/SecondaryHeading";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { Link } from "react-router-dom";
import MainButton from "../MainButton/MainButton";
import Title from "../../common/Title/Title";
import AuxiliaryText from "../Typography/AuxiliaryText";
import SpecialText from "../Typography/SpecialText";
import Pro from "../Tags/Pro";
import Featured from "../Tags/Featured";
import Basic from "../Tags/Basic";
import { useSelector } from "react-redux";
import SharePopup from "../SharePopup/SharePopup";

const DashboardAdscard = ({
  postData,
  sellerName,
  category,
  serviceName,
  serviceDescription,
  type,
  Images,
  rating,
  postTitle,
  companyLogo,
  serviceId,
  Col,
  companyId,
  replaceLink,
  reaction,
  selfWidth,
  likes,
  views,
  additionalActions,
  viewButton,
  editButton,
  uploadButton,
  deleteButton,
  previewButton,
  editOnClick,
  uploadOnClick,
  viewOnClick,
  deleteOnClick,
  previewOnClick,
  shareButton = true,
  saveButton = true,
  isFeatured = false,
}) => {
  const id = useMemo(() => Math.round(Math.random() * 1000), []);
  const [heartClick, setheartClick] = useState(reaction);
  const navigate = useNavigate();
  const { auth } = useAuth();
  const [SignUpState, setSignUpState] = React.useState(false);
  const [SignIn, setSignIn] = React.useState(false);
  const [sharePopupOpen, setSharePopupOpen] = useState(false);

  // Get business details from Redux
  const { businessName, profilePicture, userPlan } = useSelector((state) => state.user);

  // Memoize the image source to prevent unnecessary re-renders
  const imageSource = useMemo(() => {
    if (Array.isArray(Images) && Images.length > 1) {
      return Images;
    }
    return Images?.[0]?.url ?? Images?.[0] ?? require("../../../assets/img/default-post-image.webp");
  }, [Images]);

  useEffect(() => {
    setheartClick(reaction);
  }, [reaction]);

  const handleActionClick = (e, callback) => {
    e.stopPropagation();
    if (callback) {
      callback();
    }
  };

  const { mutate } = useServiceLikeMutation();
  const handleLike = (serviceId, reaction) => {
    if (!auth?.user) {
      setSignIn(true);
    } else {
      setheartClick(!heartClick);
      mutate({
        userId: auth.user.id,
        serviceId: serviceId,
        reaction: !reaction,
      });
    }
  };

  // Handle share button click
  const handleShareClick = (e) => {
    e.stopPropagation();
    setSharePopupOpen(true);
  };

  // Generate the share URL for this post
  const shareUrl = `${window.location.origin}/service-detail/?id=${serviceId}`;

  const location = useLocation();
  return (
    <>
      {SignIn && (
        <Login
          location={location.pathname + location.search}
          SignIn={SignIn}
          setSignIn={setSignIn}
          SignUpState={SignUpState}
          setSignUpState={setSignUpState}
        />
      )}
      {SignUpState && (
        <SignUp
          location={location.pathname + location.search}
          SignUpState={SignUpState}
          setSignUpState={setSignUpState}
          SignIn={SignIn}
          setSignIn={setSignIn}
        />
      )}
      <div className="relative aspect-[413/309.75]">
        <div className="group/main cursor-pointer relative overflow-hidden">
          <div
            className="div1 hidden group-hover/main:block absolute z-10 top-1/4 px-3 w-full h-full"
            onClick={() => {
              navigate({
                pathname: "/service-detail/",
                search: `?${createSearchParams({
                  id: serviceId,
                })}`,
              });
            }}
          >
            <div className="flex flex-col justify-between -mt-[15%] h-[88%] w-full">
              <div className="flex flex-col w-[40px]">
                {/* {shareButton && (
                  <Title text={"Share this post"} width={"100"}>
                    <div className="flex items-center justify-center bg-white rounded-full w-[40px] h-[40px] relative group">
                      <button onClick={handleShareClick}>
                        <i className="fi fi-rs-share text-base text-offblack cursor-pointer duration-500 transition-all group-hover:text-mediumgray flex items-center justify-center"></i>
                      </button>
                    </div>
                  </Title>
                )} */}
                {saveButton && (
                  <Title text={"Save this post"} width={"100"}>
                    <div className="flex items-center justify-center bg-white rounded-full w-[40px] h-[40px] relative mt-2 group">
                      <span
                        onClick={(e) => {
                          handleActionClick(e, () => handleLike(serviceId, reaction));
                        }}
                      >
                        <i 
                          className={`fi fi-rs-heart text-base cursor-pointer duration-500 transition-all flex items-center justify-center group-hover:text-alertred ${
                            heartClick === true
                              ? "text-alertred"
                              : "text-offblack"
                          }`}
                        ></i>
                      </span>
                    </div>
                  </Title>
                )}
              </div>
              {additionalActions && (
                <div className="flex items-center justify-center gap-x-1">
                  {editButton && (
                    <Title text={"Edit"} width={"50"}>
                      <div
                        onClick={(e) => {
                          handleActionClick(e, editOnClick);
                        }}
                        className="flex items-center justify-center bg-white rounded-full w-[40px] h-[40px] relative group"
                      >
                        <i className="fi fi-rr-pencil text-base text-offblack group-hover:text-mediumgray flex items-center justify-center"></i>
                      </div>
                    </Title>
                  )}
                  {uploadButton && (
                    <Title text={"Upload"} width={"50"}>
                      <div
                        onClick={(e) => {
                          handleActionClick(e, uploadOnClick);
                        }}
                        className="flex items-center justify-center bg-white rounded-full w-[40px] h-[40px] relative"
                      >
                        <i className="fi fi-rs-inbox-out text-base text-mediumgray hover:text-mediumgray"></i>
                      </div>
                    </Title>
                  )}
                  {viewButton && (
                    <Title text={"View"} width={"50"}>
                      <div
                        onClick={(e) => {
                          handleActionClick(e, viewOnClick);
                        }}
                        className="flex items-center justify-center bg-white rounded-full w-[40px] h-[40px] relative group"
                      >
                        <i className="fi fi-rs-eye text-base text-offblack group-hover:text-mediumgray flex items-center justify-center"></i>
                      </div>
                    </Title>
                  )}
                  {deleteButton && (
                    <Title text={"Delete"} width={"50"}>
                      <div
                        onClick={(e) => {
                          handleActionClick(e, deleteOnClick);
                        }}
                        className="flex items-center justify-center bg-white rounded-full w-[40px] h-[40px] relative group"
                      >
                        <i className="fi fi-rr-trash text-base text-offblack group-hover:text-mediumgray flex items-center justify-center"></i>
                      </div>
                    </Title>
                  )}
                  {previewButton && (
                    <Title text={"Preview"} width={"60"}>
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          const previewUrl = `${window.location.origin}/service-detail/?id=${serviceId}`;
                          window.open(previewUrl, '_blank');
                        }}
                        className="flex items-center justify-center bg-white rounded-full w-[40px] h-[40px] relative group"
                      >
                        <i className="fi fi-rr-eye text-base text-offblack group-hover:text-mediumgray flex items-center justify-center"></i>
                      </div>
                    </Title>
                  )}
                </div>
              )}
              <div className="text-white w-full">
                <div
                  className={`flex gap-x-2 cursor-pointer ${Array.isArray(imageSource) && imageSource.length > 1 ? 'mb-4' : ''}`}
                  onClick={() => {
                    navigate(
                      {
                        pathname: "/poster-profile/",
                        search: `?${createSearchParams({
                          id: companyId,
                          name: postTitle,
                        })}`,
                      },
                      { replace: replaceLink }
                    );
                  }}
                >
                  <div className="flex flex-col">
                    <SecondaryHeading
                      variant={"MainParagraphHeading"}
                      className={
                        "w-full overflow-hidden text-ellipsis break-words !font-normal"
                      }
                    >
                      {/* {postTitle?.split(/\s+/).slice(0, 3).join(" ")} */}
                      {postTitle}
                    </SecondaryHeading>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {Array.isArray(imageSource) && imageSource.length > 1 && (
            <div className={`custom-pagination-${id} absolute bottom-0 w-full flex items-center justify-center gap-0 py-3 [&_.swiper-pagination-bullet]:w-2 [&_.swiper-pagination-bullet]:h-2 [&_.swiper-pagination-bullet]:rounded-full [&_.swiper-pagination-bullet]:bg-white [&_.swiper-pagination-bullet]:opacity-50 [&_.swiper-pagination-bullet-active]:!opacity-100 [&_.swiper-pagination-bullet]:!mx-1 [&_.swiper-pagination-bullet]:transition-all [&_.swiper-pagination-bullet]:duration-300 [&_.swiper-pagination-bullet]:hover:scale-110 [&_.swiper-pagination-bullet]:cursor-pointer [&_.swiper-pagination-bullet]:shadow-[0_2px_4px_rgba(0,0,0,0.2)] z-[19]`}></div>
          )}
          <div className="relative w-full aspect-[413/309.75]">
            {Array.isArray(imageSource) && imageSource.length > 1 ? (
              <Swiper
                modules={[Pagination]}
                pagination={{
                  clickable: true,
                  bulletClass: 'swiper-pagination-bullet',
                  bulletActiveClass: 'swiper-pagination-bullet-active',
                  el: `.custom-pagination-${id}`,
                }}
                className="w-full h-full rounded-xl"
              >
                {imageSource.map((image, index) => (
                  <SwiperSlide key={index} className="!w-full">
                    <div className="relative w-full h-full">
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover/main:opacity-50 transition-opacity duration-300 h-4/1 bottom-0 z-[2] rounded-xl"></div>
                      <img
                      onClick={() => {
                        navigate({
                          pathname: "/service-detail/",
                          search: `?${createSearchParams({
                            id: serviceId,
                          })}`,
                        });
                      }}
                        className="cursor-pointer rounded-xl object-cover w-full h-full"
                        src={image.url || image}
                        alt={`product image ${index + 1}`}
                        onError={(e) => {
                          e.target.src = require("../../../assets/img/default-image.jpg");
                        }}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <div className="relative w-full h-full">
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover/main:opacity-50 transition-opacity duration-300 h-4/1 bottom-0 z-[2] rounded-xl"></div>
                <img
                  onClick={() => {
                    navigate({
                      pathname: "/service-detail/",
                      search: `?${createSearchParams({
                        id: serviceId,
                      })}`,
                    });
                  }}
                  className="cursor-pointer rounded-xl object-cover w-full h-full"
                  src={imageSource}
                  alt="product images"
                  onError={(e) => {
                    e.target.src = require("../../../assets/img/default-image.jpg");
                  }}
                />
              </div>
            )}
            <div className="absolute z-10 -mt-[73%] right-2 flex flex-col gap-1">
              {isFeatured && (
                <div className="bg-primaryblue rounded-[4px] text-white px-1 py-[2px] mt-1" style={{ lineHeight: 'normal' }}>
                  <AuxiliaryText variant={"Infographic"}>Featured</AuxiliaryText>
                </div>
              )}
              {/* {userPlan?.plan?.name?.toLowerCase() === 'pro' && (
                <div className="bg-primaryblue text-white px-[2px] pt-[1px] mt-1">
                  <AuxiliaryText variant={"Infographic"}>Pro</AuxiliaryText>
                </div>
              )} */}
            </div>
          </div>
        </div>
        <div className="relative text-offblack">
          <div className="flex items-center justify-between w-full mt-3 h-[24px]">
            <div className="flex gap-x-3">
              <div className="group/profile relative">
                <img
                  className="avatar-extra-small object-cover object-center cursor-pointer"
                  src={
                    !profilePicture || profilePicture === "null"
                      ? require("../../../assets/img/default-image.jpg")
                      : profilePicture
                  }
                  alt={"no-image"}
                  onError={(e) => {
                    e.target.src = require("../../../assets/img/default-image.jpg");
                  }}
                />
                {/* <div className="hidden lg:group-hover/profile:block absolute z-20"> */}
                <div className="hidden absolute z-20">
                  <div
                    className={`bg-white -ml-2 -mt-[240px] w-[350px] sm:w-[400px] h-[200px] rounded-xl p-5`}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <div className="relative">
                          <img
                            className="avatar-small object-cover object-center cursor-pointer"
                            src={require("../../../assets/img/User.png")}
                            // src={
                            //   !companyLogo || companyLogo === "null"
                            //     ? require("../../../assets/img/hero-vector.svg").default
                            //     : companyLogo
                            // }
                            alt={"no-image"}
                            // onError={(e) => {
                            //     e.target.src = require("../../assets/img/default-image.jpg");
                            //   }}
                          />
                          <div className="absolute -mt-3 left-[30%]">
                            <div className="mt-[1px] mr-3">
                              <Pro className={"bg-primaryblue text-white"} />
                            </div>
                          </div>
                        </div>
                        <div className="ml-3">
                          <div>
                            <SpecialText variant={"ProfileName"}>
                              Architecture
                              {/* {heading} */}
                            </SpecialText>
                          </div>
                          <div>
                            <SpecialText variant="ProfileMicro">
                              Duffy, ACT, 2611
                            </SpecialText>
                          </div>
                        </div>
                      </div>
                      <div>
                        <MainButton variant={"outlinesmall"}>
                          Follow
                        </MainButton>
                      </div>
                    </div>
                    <div className="flex items-center justify-between mt-5">
                      <div className="w-[100px] sm:w-[109px] h-[82px]">
                        <img
                          src={require("../../../assets/img/default-image.jpg")}
                          className="w-full h-full rounded-xl object-center"
                          alt="portfolio"
                        />
                      </div>
                      <div className="w-[100px] sm:w-[109px] h-[82px]">
                        <img
                          src={require("../../../assets/img/default-image.jpg")}
                          className="w-full h-full rounded-xl object-center"
                          alt="portfolio"
                        />
                      </div>
                      <div className="w-[100px] sm:w-[109px] h-[82px]">
                        <img
                          src={require("../../../assets/img/default-image.jpg")}
                          className="w-full h-full rounded-xl object-center"
                          alt="portfolio"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="w-0 h-0 border-l-[10px] border-l-transparent border-t-[15px] border-t-white border-r-[10px] border-r-transparent ml-1"></div>
                </div>
              </div>
              <div className="flex items-center gap-x-2">
                <SpecialText
                  className={"overflow-hidden text-ellipsis text-offblack"}
                  variant={"ProfileName"}
                  onClick={() => {
                    navigate({
                      pathname: "/service-detail/",
                      search: `?${createSearchParams({
                        id: serviceId,
                      })}`,
                    });
                  }}
                >
                  {businessName || "Business Name"}
                </SpecialText>
                {userPlan?.plan?.name?.toLowerCase() === 'pro' ? (
                  <Pro
                    className={
                      "bg-mediumgray text-white hover:bg-offblack"
                    }
                  />
                ) : null}
              </div>
            </div>
            <div className={`flex items-center gap-x-2 h-[24px] ${location.pathname.includes("/business-dashboard/posts/create-post") ? "hidden" : ""}`}>
              <div className="flex items-center">
                <div
                  onClick={(e) => {
                    handleActionClick(e, () => handleLike(serviceId, reaction));
                  }}
                >
                  <IconContext.Provider
                    value={{
                      className: `size-4 sm:size-4 cursor-pointer duration-500 trasition-all flex items-center justify-center ${
                        heartClick === true
                          ? "text-alertred"
                          : "text-mediumgray hover:text-alertred"
                      } `,
                    }}
                  >
                    <Heart />
                  </IconContext.Provider>
                </div>
                <SpecialText
                  variant={"Counter"}
                  className={"ml-1 text-offblack"}
                >
                  {likes || 0}
                </SpecialText>
              </div>
              <div className="flex items-center h-[24px]">
                <div
                  onClick={(e) => {
                    handleActionClick(e, () => handleLike(serviceId, reaction));
                  }}
                >
                  <i className="fi fi-ss-eye text-base sm:text-base text-mediumgray duration-500 trasition-all hover:text-offblack flex items-center justify-center"></i>
                </div>
                <div>
                  <SpecialText
                    variant={"Counter"}
                    className={"ml-1 text-offblack"}
                  >
                    {views || 0}
                  </SpecialText>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
              {sharePopupOpen && (
          <SharePopup
            isOpen={sharePopupOpen}
            onClose={() => setSharePopupOpen(false)}
            postTitle={postTitle}
            currentUrl={shareUrl}
          />
        )}
    </>
  );
};

export default DashboardAdscard;
